import useSize from "../../../../../Utils/useSize/useSize";
import Menu from "./Menu/Menu";
import Filter from "./Filter/Filter";
import TradeCard from "./TradeCard";

export default function Trade(props) {
  const windowSize = useSize();

  const item = props.item;

  return (
    <div
      className="background border primary-border"
      style={{
        width: windowSize[0] - 200,
        height: windowSize[1] - 120,
        borderRadius: 10,
      }}
    >
      <Filter close={props.close} />
      <Menu />

      <div
        style={{
          height: windowSize[1] - 190,
          display: "flex",
          flexDirection: "column",
          overflowY: "scroll",
        }}
      >
        {item.trade.length > 0
          ? item.trade.map((item) => {
              return <TradeCard key={item.id} item={item} />;
            })
          : null}
      </div>
    </div>
  );
}
